import React, { createContext, useEffect, useState } from "react";
import { toast as sonnerToast } from "sonner";

const AuthContext = createContext();

const SONNER_TOAST_BY_TYPE = {
  success: sonnerToast.success,
  error: sonnerToast.error,
  warning: sonnerToast.warning,
  info: sonnerToast.info,
};

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(false);
  const [loginType, setLoginType] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [walletSummary, setWalletSummary] = useState({});
  const [isWalletRefresh, setIsWalletRefresh] = useState(false);

  const showToast = (message, type) => {
    (SONNER_TOAST_BY_TYPE[type] || sonnerToast)(message);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      setAuth(true);
    }
  }, []);

  const managerRoutes = [
    "/",
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
    "/verify-email",
    "/resend-verification-email",
  ];

  const memberRoutes = ["/", "/profile", "/dashboard", "/settings", "/logout"];

  const superAdminRoutes = [
    "/",
    "/profile",
    "/dashboard",
    "/settings",
    "/logout",
  ];

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        managerRoutes,
        memberRoutes,
        superAdminRoutes,
        loginType,
        setLoginType,
        setUserDetails,
        userDetails,
        walletSummary,
        setWalletSummary,
        setIsWalletRefresh,
        isWalletRefresh,
        showToast,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext };
